import { render, staticRenderFns } from "./whOrderMain.vue?vue&type=template&id=51340d4d&scoped=true&"
import script from "./whOrderMain.vue?vue&type=script&lang=js&"
export * from "./whOrderMain.vue?vue&type=script&lang=js&"
import style0 from "./whOrderMain.vue?vue&type=style&index=0&id=51340d4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51340d4d",
  null
  
)

export default component.exports